import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_ontos_property_editor = _resolveComponent("ontos-property-editor")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    fullscreen: _ctx.$vuetify.display.smAndDown,
    "max-width": "1120px",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ontos_property_editor, {
        idea: _ctx.idea,
        workspace: _ctx.workspace,
        property: _ctx.property,
        identifier: _ctx.identifier,
        saving: _ctx.saving,
        onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save', $event)))
      }, {
        controls: _withCtx(({dirty, resume}) => [
          _createVNode(_component_ontos_dialog_actions, {
            "on-full-page": () => _ctx.expand(resume),
            dirty: dirty,
            disabled: _ctx.saving,
            onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
          }, null, 8, ["on-full-page", "dirty", "disabled"])
        ]),
        _: 1
      }, 8, ["idea", "workspace", "property", "identifier", "saving"])
    ]),
    _: 1
  }, 8, ["fullscreen"]))
}